import { render, staticRenderFns } from "./ReportCustomerBill.vue?vue&type=template&id=1b4a6dd2"
import script from "./ReportCustomerBill.vue?vue&type=script&lang=js"
export * from "./ReportCustomerBill.vue?vue&type=script&lang=js"
import style0 from "./ReportCustomerBill.vue?vue&type=style&index=0&id=1b4a6dd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports